// What a pull request is, as GitHub's own glyph says it: open, a draft,
// merged or closed. From fields every row already has.

export type PrKind = 'open' | 'draft' | 'merged' | 'closed';

export const PR_KIND_TEXT: Record<PrKind, string> = { open: 'Open', draft: 'Draft', merged: 'Merged', closed: 'Closed' };

export function prKind(pr: { state: 'OPEN' | 'CLOSED' | 'MERGED'; isDraft: boolean }): PrKind {
  if (pr.state === 'MERGED') return 'merged';
  if (pr.state === 'CLOSED') return 'closed';
  return pr.isDraft ? 'draft' : 'open';
}
